<template>
    <div>
        <v-simple-table>
            <template v-slot:default>
                <thead>
                    <tr>
                        <th class="text-left">
                            Class Course
                        </th>
                        <th class="text-left">
                            Teacher
                        </th>
                        <th class="text-left">
                            Date & Time
                        </th>
                        <th>
                            Actions
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="request in requests" :key="request.id">
                        <td class="py-3">
                            <div class="d-flex align-center">
                                <router-link class="me-3" :to="{name: 'course', params: {id: request.enrollment.course.id}}">
                                    <v-avatar tile width="60" height="50" style="border-radius: 5px!important" v-ripple="{class: 'black--text'}">
                                        <v-img :src="request.enrollment.course.image_url" />
                                    </v-avatar>
                                </router-link>
                                <div>
                                    <div class="strong-text--text nowrap mb-1 font-weight-medium">{{request.enrollment.course.name}}</div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <v-chip class="font-weight-medium" text small label>
                                {{request.teacher.name}}
                            </v-chip>
                        </td>
                        <td>
                            <div>
                                <v-chip color="teal" text class="teal lighten-5 teal--text text--darken-2 font-weight-bold mb-1">
                                    <v-icon left>mdi-clock-outline</v-icon>
                                    <span>{{request.start_formated}}</span>
                                </v-chip>
                                <v-chip color="deep-orange" text class="deep-orange lighten-5 deep-orange--text text--darken-2 font-weight-bold">
                                    <v-icon left>mdi-clock-end</v-icon>
                                    <span>to {{request.end_formated}}</span>
                                </v-chip>
                            </div>
                        </td>
                        <td style="white-space: nowrap;">
                            <v-btn color="teal" dark class="me-2" @click="showApproveDialog(request)">
                                Approve
                            </v-btn>
                            <v-btn color="red" dark @click="showRejectDialog(request)">
                                Reject
                            </v-btn>
                        </td>
                    </tr>
                </tbody>
            </template>
        </v-simple-table>

        <v-dialog v-model="approveDialog" max-width="350">
            <v-card>
                <v-card-title>Confirm Makeup Class</v-card-title>
                <v-card-text>
                    Are you sure that you want to approve this makeup class? It will be added to your calendar immediately.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="approving" @click="approveDialog = false">Cancel</v-btn>
                    <v-btn :loading="approving" :disabled="approving" text color="success" @click="approveRequest(approveRequestId)">Confirm</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="rejectDialog" max-width="350">
            <v-card>
                <v-card-title>Reject Makeup Class</v-card-title>
                <v-card-text>
                    Are you sure that you want to reject this makeup class request?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="muted" :disabled="rejecting" @click="rejectDialog = false">Cancel</v-btn>
                    <v-btn :loading="rejecting" :disabled="rejecting" text color="red" @click="rejectRequest(rejectRequestId)">Reject</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
export default {
    props: {
        requests: Array
    },
    data(){
        return {
            approving: false,
            approveRequestId: null,
            approveDialog: false,

            rejecting: false,
            rejectRequestId: null,
            rejectDialog: false,
        }
    },
    computed: {
        ...GlobalComputed,
    },
    methods: {
        ...GlobalMethods,

        showApproveDialog(request){
            this.approveRequestId = request.id;
            this.approveDialog = true;
        },
        showRejectDialog(request){
            this.rejectRequestId = request.id;
            this.rejectDialog = true;
        },
        approveRequest(id){
            if (!this.approving){
                this.approving = true;
                return this.$store.dispatch('makeupClassRequestAction', {action: 'approve', id: this.approveRequestId}).then(response=>{
                    this.approving = false;
                    this.showMsg('Makeup class has been approved and added to your calendar', 'success');
                    this.$router.push({name: 'calendar'});
                }).catch(error=>{
                    this.approving = false;
                    const msg = error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'Error occurred during performing your action';
                    this.showMsg(msg, 'error');
                })
            }
        },
        rejectRequest(id){
            if (!this.rejecting){
                this.rejecting = true;
                return this.$store.dispatch('makeupClassRequestAction', {action: 'reject', id: this.rejectRequestId}).then(response=>{
                    this.rejecting = false;
                    this.showMsg('Makeup class request rejected successfully', 'success');
                    this.$emit('load');
                }).catch(error=>{
                    this.rejecting = false;
                    this.showMsg('Error occurred during performing your action', 'error');
                })
            }
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
